import { blogs } from "../data/blogs";
import BlogCard from "../components/BlogCard";
import { useState } from "react";

export default function Home() {
  const [search, setSearch] = useState("");

  const filtered = blogs.filter(blog =>
    blog.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h1 className="text-4xl font-bold mb-4 text-center">React Interview Blog</h1>

      <input
        type="text"
        className="border rounded px-4 py-2 w-full mb-6"
        placeholder="Search blogs..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="grid md:grid-cols-2 gap-6">
        {filtered.map(blog => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </div>
  );
}
